import React from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import UpdateReservation from '../UpdateReservation';

const Column = ({ columnId, title, tasks, onRefresh }) => (
    <Droppable droppableId={columnId}>
        {(provided, snapshot) => (
            <div
                className={`reservation-kanban-column ${snapshot.isDraggingOver ? 'is-dragging-over' : ''}`}
                ref={provided.innerRef}
                {...provided.droppableProps}
            >
                <h6 className="reservation-kanban-column__title">{title}</h6>
                <div className="reservation-kanban-column__tasks">
                    {tasks.length === 0 && (
                        <div className="reservation-kanban-column__empty">No reservations</div>
                    )}
                    {tasks.map((task, index) => (
                        <Draggable key={task.id} draggableId={task.id} index={index} isDragDisabled={task.isDragDisabled}>
                            {(dragProvided, dragSnapshot) => (
                                <div
                                    className={`reservation-kanban-card ${dragSnapshot.isDragging ? 'is-dragging' : ''}`}
                                    ref={dragProvided.innerRef}
                                    {...dragProvided.draggableProps}
                                    {...dragProvided.dragHandleProps}
                                >
                                    <div className="reservation-kanban-card__guest">{task.row?.displayName || '-'}</div>
                                    {task.row?.hasPropertyCode && (
                                        <div className="reservation-kanban-card__property">
                                            {task.row.isPropertyLoading ? (
                                                <span className="property-loader">
                                                    <i className="simple-icon-refresh spinning" />
                                                    Loading property…
                                                </span>
                                            ) : (
                                                task.row.propertyName && (
                                                    <>
                                                        <i className="simple-icon-location-pin mr-1" />
                                                        {task.row.propertyName}
                                                    </>
                                                )
                                            )}
                                        </div>
                                    )}
                                    <div className="reservation-kanban-card__date">{task.row?.checkInDisplay || '-'}</div>
                                    <div className="reservation-kanban-card__date">{task.row?.checkOutDisplay || '-'}</div>
                                    <div className="reservation-kanban-card__actions">

                                        {task.isDragDisabled && (
                                            <div className="reservation-kanban-card__lock-wrapper">
                                                <button type="button" className="reservation-kanban-card__lock-btn">
                                                    <i className="simple-icon-lock" />
                                                </button>
                                                <div className="reservation-kanban-card__tooltip">
                                                    Synced from PMS
                                                </div>
                                            </div>
                                        )}
                                        <UpdateReservation
                                            row={task.row}
                                            onSuccess={onRefresh}
                                            renderTrigger={({ onClick }) => (
                                                <button
                                                    type="button"
                                                    className="reservation-kanban-card__edit-btn"
                                                    onClick={onClick}
                                                    aria-label="Edit reservation"
                                                >
                                                    <i className="simple-icon-note" />
                                                </button>
                                            )}
                                        />
                                    </div>
                                </div>
                            )}
                        </Draggable>
                    ))}
                    {provided.placeholder}
                </div>
            </div>
        )}
    </Droppable>
);

export default Column;


